<template lang="html">
	<div class="user-assessment">
		<div class="title-content">
			<div class="title">User Assessments</div>
		</div>

		<div class="row">
			<div class="col-12 col-lg-10 col-xl-9">
				<div class="profile-card">
					<div class="border white-card">
						<div
							class="assessment-content"
							v-for="(assessment, index) in assessmentFields"
							:key="index"
						>
							<div
								class="row"
								v-if="
									assessment.question &&
									assessment.self_assessment &&
									assessment.self_assessment.answer &&
									assessment.question !== ''
								"
							>
								<div class="col-12 col-md-9 col-lg-10">
									<div class="question">
										<span class="num">{{ index }}. </span
										>{{ assessment.question }}
									</div>
								</div>
								<div class="col-12 col-md-3 col-lg-2">
									<div class="answer">
										{{ assessment.self_assessment.answer }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import assessment from '../rsc/stores/user-assessment.store';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('assessment');
	},
	created() {
		utils.registerModule('assessment', assessment, this.$store);
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters(['loading', 'assessmentFields']),
	},
	methods: {
		...mapActions(['fetchAssessments']),
	},
	mounted() {
		utils.registerModule('assessment', assessment, this.$store);
		this.fetchAssessments();
	},
};
</script>

<style lang="less">
.user-assessment {
	.white-card {
		background: var(--white);
		border-radius: 4px !important;
		padding: 20px;

		.assessment-content {
			margin: 15px 0;

			.answer {
				font-size: 14px;
				font-weight: 600;
				text-transform: uppercase;
				color: var(--secondary);
			}
			.question {
				font-size: 13px;
				font-weight: 600;
				color: var(--primary);
			}
		}
	}
}
</style>
